import { getConfig } from '../../../utils/getConfig.js';
import { Plan } from '../types.js';
import { getPlan } from './getPlan.js';

export const getPlans = (): Plan[] => {
  return [getPlan(getConfig('STRIPE_PRICE_MONTHLY')), getPlan(getConfig('STRIPE_PRICE_YEARLY'))];
};
